<template>
  <div>
    <section class="checklist-approval-area">
      <div
        class="d-flex align-center"
        style="gap: 14px;"
      >
        <div
          class="checklist-approval-icon-box"
          :style="{ backgroundColor: isApproved ? '#56CA00' : '#FF4C51' }"
        >
          <v-icon
            size="24"
            color="white"
          >
            {{ computedIcon }}
          </v-icon>
        </div>
        <div class="d-flex flex-column">
          <span style="font-weight: 600; font-size: 15px; color: #E7E3FC;">{{ computedTitle }}</span>
          <span style="font-weight: 500; font-size: 13px; color: #E7E3FC;">{{ computedText }}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axiosIns from '@/plugins/axios'
import {
  mdiClipboardCheckOutline, mdiThumbDown, mdiThumbDownOutline, mdiThumbUp, mdiThumbUpOutline,
} from '@mdi/js'

export default {
  name: 'ChecklistApprovalArea',
  props: {
    isApproved: {
      type: Boolean,
      required: true,
    },
    reviewer: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      icons: {
        mdiClipboardCheckOutline, mdiThumbDownOutline, mdiThumbUpOutline, mdiThumbUp, mdiThumbDown,
      },
      showDisapproveModal: false,
      showApproveModal: false,
      showConfirmApproveDialog: false,
    }
  },
  computed: {
    computedIcon() {
      return this.isApproved ? this.icons.mdiThumbUp : this.icons.mdiThumbDown
    },
    computedTitle() {
      return this.isApproved ? 'Checklist aprovado' : 'Checklist recusado'
    },
    computedText() {
      const reviewerName = this.reviewer?.name || ''
      const formattedDate = this.formatDateTime(this.reviewer?.updated_at)

      return this.isApproved
        ? `${reviewerName} aprovou o checklist no dia ${formattedDate}.`
        : `${reviewerName} reprovou o checklist no dia ${formattedDate}.`
    },
  },
  methods: {
    formatDateTime(dateTime) {
      if (!dateTime) return '00/00/0000-00:00:00'

      try {
        const date = new Date(dateTime)
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')

        return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`
      } catch (error) {
        return '00/00/0000-00:00:00'
      }
    },
    async confirmApproveWithoutIssues() {
      try {
        const payload = {
          action: 'approve',
          description: '',
        }

        const { data } = await axiosIns.patch(
          `/api/v1/solicitations/transport_vehicle_checklist/approve_or_reject/${this.checklistId}`,
          payload,
        )

        this.$swal({
          icon: 'success',
          title: 'Checklist Aprovado',
          text: 'O checklist foi aprovado e a viagem foi liberada com sucesso.',
        })

        this.$emit('approve', data)
        this.showConfirmApproveDialog = false
      } catch (error) {
        console.error('Erro ao aprovar checklist:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível aprovar o checklist. Tente novamente.',
        })
      }
    },
    async handleDisapprove(description) {
      try {
        const payload = {
          action: 'reject',
          description,
        }

        const { data } = await axiosIns.patch(
          `/api/v1/solicitations/transport_vehicle_checklist/approve_or_reject/${this.checklistId}`,
          payload,
        )

        this.$swal({
          icon: 'success',
          title: 'Checklist Recusado',
          text: 'O checklist foi recusado com sucesso.',
        })

        this.$emit('disapprove', data)
        this.showDisapproveModal = false
      } catch (error) {
        console.error('Erro ao recusar checklist:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível recusar o checklist. Tente novamente.',
        })
      }
    },
    async handleApprove(description) {
      try {
        const payload = {
          action: 'approve',
          description,
        }

        const { data } = await axiosIns.patch(
          `/api/v1/solicitations/transport_vehicle_checklist/approve_or_reject/${this.checklistId}`,
          payload,
        )

        this.$swal({
          icon: 'success',
          title: 'Checklist Aprovado',
          text: 'O checklist foi aprovado e a viagem foi liberada com sucesso.',
        })

        this.$emit('approve', data)
        this.showApproveModal = false
      } catch (error) {
        console.error('Erro ao aprovar checklist:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível aprovar o checklist. Tente novamente.',
        })
      }
    },
  },
}
</script>

<style scoped>
.checklist-approval-area {
  border: 1px solid #534D74;
  background: transparent;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  gap: 32px;
  padding: 32px;
}
.checklist-approval-icon-box {
  width: 41px;
  height: 41px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checklist-approval-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
}
</style>
